import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { TranslatePipe } from '@ngx-translate/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { LocalLanguageService } from '../../../core/services/local-language.service';

@Component({
  selector: 'cap-gwr-link',
  imports: [TranslatePipe, NgbTooltip],
  templateUrl: './gwr-link.component.html',
  styleUrl: './gwr-link.component.scss'
})
export class GwrLinkComponent implements OnInit {
  @Input()
  egid: string;

  readonly URL = 'https://www.housing-stat.ch/egid/';
  hasExternalGwr: boolean = environment.gwrServerUrl !== null;

  private isHousingStat: boolean;

  constructor(private localLanguageService: LocalLanguageService) {}

  ngOnInit(): void {
    this.isHousingStat = environment.gwrServerUrl?.includes('housing-stat.ch');
  }

  get externerGwrLink(): string {
    if (this.isHousingStat) {
      return this.URL + this.egid + '?lang=' + this.localLanguageService.getLocalLanguage();
    } else {
      return environment.gwrServerUrl + '?egid=' + this.egid;
    }
  }
}
